// ! TODO: [2] Add missing tests
// istanbul ignore next
export const handleFetchResponse = (response) => {
  if (response.status >= 400) {
    throw response;
  }
  return response.json();
};
